import { soundKey, sameSound, INDIC } from "./soundKey";
import { CITY_NATIVE } from "./localNameWords";

// Combined city list: Andhra Pradesh + Telangana
// Sorted alphabetically for easy selection

export const CITY_LIST_AP = [
  // ── Andhra Pradesh ──────────────────────────────────────────
  "Adoni",
  "Amalapuram",
  "Amaravati",
  "Anakapalle",
  "Anantapur",
  "Bapatla",
  "Bhimavaram",
  "Chilakaluripet",
  "Chittoor",
  "Dharmavaram",
  "Eluru",
  "Gooty",
  "Gudur",
  "Guntur",
  "Hindupur",
  "Jaggaiahpet",
  "Jammalamadugu",
  "Kadapa",
  "Kakinada",
  "Kandukur",
  "Kavali",
  "Kurnool",
  "Machilipatnam",
  "Madanapalle",
  "Markapur",
  "Nandyal",
  "Narasaraopet",
  "Nellore",
  "Ongole",
  "Palasa",
  "Piduguralla",
  "Proddatur",
  "Puttaparthi",
  "Rajahmundry",
  "Rayachoti",
  "Srikakulam",
  "Tadepalligudem",
  "Tadipatri",
  "Tanuku",
  "Tenali",
  "Tirupati",
  "Tuni",
  "Vijayawada",
  "Visakhapatnam",
  "Vizianagaram",
  "Yemmiganur",

  // ── Telangana ────────────────────────────────────────────────
  "Adilabad",
  "Armoor",
  "Asifabad",
  "Badepally",
  "Bhadrachalam",
  "Bhongir",
  "Bodhan",
  "Devarakonda",
  "Gadwal",
  "Hyderabad",
  "Jagitial",
  "Jangaon",
  "Jagtial",
  "Kamareddy",
  "Karimnagar",
  "Khammam",
  "Korutla",
  "Kothagudem",
  "Kyathampalle",
  "Mahabubabad",
  "Mahabubnagar",
  "Mancherial",
  "Medak",
  "Miryalaguda",
  "Nalgonda",
  "Narayanpet",
  "Nirmal",
  "Nizamabad",
  "Palwancha",
  "Peddapalli",
  "Ramagundam",
  "Sangareddy",
  "Secunderabad",
  "Siddipet",
  "Siricilla",
  "Suryapet",
  "Tandur",
  "Vikarabad",
  "Wanaparthy",
  "Warangal",
  "Yellandu",
  "Zaheerabad",
].sort();

// Telangana-only subset (for filtering if needed)
export const CITY_LIST_TG = [
  "Adilabad","Armoor","Asifabad","Badepally","Bhadrachalam","Bhongir",
  "Bodhan","Devarakonda","Gadwal","Hyderabad","Jagitial","Jangaon",
  "Jagtial","Kamareddy","Karimnagar","Khammam","Korutla","Kothagudem",
  "Kyathampalle","Mahabubabad","Mahabubnagar","Mancherial","Medak",
  "Miryalaguda","Nalgonda","Narayanpet","Nirmal","Nizamabad","Palwancha",
  "Peddapalli","Ramagundam","Sangareddy","Secunderabad","Siddipet",
  "Siricilla","Suryapet","Tandur","Vikarabad","Wanaparthy","Warangal",
  "Yellandu","Zaheerabad",
].sort();

/* ── A city named in any language ───────────────────────────────────────────────
   The list is in English, and so are the cars. A customer reading the app in Telugu
   types "విజయవాడ", and Google - which answers in the phone's language - may say the
   same; either way the name matched nothing and the list came back with no cars. Here
   a name in any of the app's scripts is heard rather than spelled (utils/soundKey), and
   the old, short and official new names people use count as the city too. */

// Other names for a city - the old one, the short one, the official new one.
export const CITY_ALIASES = {
  Visakhapatnam: ["Vizag", "Visakha", "Vishakapatnam", "Vishakhapatnam", "Waltair"],
  Vijayawada: ["Bezawada", "Bejawada"],
  Rajahmundry: ["Rajamahendravaram", "Rajamundry", "Rajamahendri"],
  Kadapa: ["Cuddapah"],
  Tirupati: ["Tirupathi"],
  Machilipatnam: ["Masulipatnam", "Bandar"],
  Anantapur: ["Anantapuramu", "Ananthapur"],
  Narasaraopet: ["Narasaravupeta", "Narasaraopeta"],
  Bhongir: ["Bhuvanagiri"],
  Jangaon: ["Janagama"],
};

/* Names too short to be told apart by sound alone - "Gooty" sounds like గుడి, a temple,
   and गाड़ी, a car - written out in each script and matched only as written. */
const NATIVE_NAMES = {
  Gooty: ["గుత్తి", "गूटी", "கூட்டி", "ಗುತ್ತಿ"],
  Tuni: ["తుని", "तुनी", "तुनि", "துனி", "ತುನಿ"],
  Khammam: ["ఖమ్మం", "खम्मम", "கம்மம்", "ಖಮ್ಮಂ"],
};

// A name as typed: one way of writing each letter (a keyboard may send ड़ as ड + ़), and
// without the invisible joiners some keyboards put between letters and others leave out.
const JOINERS = /[\u200c\u200d]/g;
const typed = (s) => String(s || "").normalize("NFC").replace(JOINERS, "").trim().replace(/\s+/g, " ");

const cityNamesOf = (c) => [c, ...(CITY_ALIASES[c] || [])];
const BY_NAME = new Map();
CITY_LIST_AP.forEach((c) => cityNamesOf(c).forEach((n) => BY_NAME.set(n.toLowerCase(), c)));
Object.entries(NATIVE_NAMES).forEach(([c, names]) => names.forEach((n) => BY_NAME.set(typed(n), c)));
/* Each city as its own people write it, in every script the app speaks - the way the list
   shows it to them - is that city exactly. A spelling two cities share (the list has both
   Jagitial and Jagtial) is left to the sound match, which lets the customer pick. */
const nativeUses = new Map();
Object.values(CITY_NATIVE).flat().forEach((n) => nativeUses.set(typed(n), (nativeUses.get(typed(n)) || 0) + 1));
const nativeOf = (c) => [...(CITY_NATIVE[c] || []), ...(NATIVE_NAMES[c] || [])].map(typed);
CITY_LIST_AP.forEach((c) => (CITY_NATIVE[c] || []).forEach((n) => {
  if (nativeUses.get(typed(n)) === 1 && !BY_NAME.has(typed(n))) BY_NAME.set(typed(n), c);
}));
const SOUNDS = [];
CITY_LIST_AP.forEach((c) => cityNamesOf(c).forEach((n) => SOUNDS.push([soundKey(n), c])));

/** The city we list for a name typed or returned in any language, or "". */
export function canonicalCity(name) {
  const raw = typed(name);
  if (!raw) return "";
  const known = BY_NAME.get(raw.toLowerCase()) || BY_NAME.get(raw);
  if (known) return known;
  // By sound only for a name in another script: an English word keeps its meaning.
  if (!INDIC.test(raw)) return "";
  const key = soundKey(raw);
  if (key.replace(/\s/g, "").length < 3) return "";
  const hits = [...new Set(SOUNDS.filter(([k]) => sameSound(k, key)).map(([, c]) => c))];
  // Two towns that sound alike (Badepally, Peddapalli), or one town the list spells two
  // ways (Jagitial, Jagtial), are left for the customer to pick from the list.
  return hits.length === 1 ? hits[0] : "";
}

/* The cities a search box offers for what has been typed so far: the English name or
   another name containing it, or - typed in another script - the cities whose sound
   begins with it. */
export function citiesMatching(query, list = CITY_LIST_AP) {
  const q = typed(query).toLowerCase();
  if (!q) return list;
  if (!INDIC.test(q)) return list.filter((c) => cityNamesOf(c).some((n) => n.toLowerCase().includes(q)));
  const exact = canonicalCity(q);
  const key = soundKey(q);
  return list.filter((c) => c === exact
    || nativeOf(c).some((n) => n.startsWith(q))
    || (!!key && cityNamesOf(c).some((n) => soundKey(n).startsWith(key))));
}

/* A search with a city in another script says that city in English ("ఏలూరు cabs" is
   "eluru cabs"), so it reaches the answer the English word does. Other words stay. */
export function cityWordsInEnglish(text) {
  const s = String(text || "");
  if (!INDIC.test(s)) return s;
  return s.split(/(\s+)/).map((w) => {
    if (!INDIC.test(w)) return w;
    const c = canonicalCity(w);
    return c ? c.toLowerCase() : w;
  }).join("");
}

// Helper: detect city from GPS using Google Maps Geocoder
/* Which of the cities we actually serve does a place sit inside?
 *
 * Google names a place by its narrowest administrative unit, which for a suburb is the
 * suburb: a pickup in Kanuru comes back with locality "Kanuru", not "Vijayawada". Taking
 * that name as the city put an unserviced value into the city field, and every check
 * anchored on the city — the pickup radius above all — then measured against a place we
 * have no coordinates or rate card for, so the booking could not proceed.
 *
 * So: walk outward from the narrowest name to the widest and take the first that is a
 * city we serve. Vijayawada is Kanuru's administrative_area_level_3, which is why that
 * level has to be in the walk — the hire picker's copy of this logic omitted it and
 * would have failed on the same address.
 *
 * Matching against a closed list of ~90 cities is what makes the loose passes safe: a
 * component only wins if it IS one of our cities, so a stray neighbourhood name cannot
 * be mistaken for one.
 *
 * Returns "" when the place is outside every serviced city. That is the honest answer
 * and leaves the field empty for the customer to correct, rather than filling it with a
 * name that cannot be booked against.
 */
const CITY_COMPONENT_PRIORITY = [
  "locality",
  "postal_town",
  "administrative_area_level_3",
  "administrative_area_level_2",
  "administrative_area_level_1",
];

/* Where each serviced city actually is. Canonical home for these coordinates: the ETA
   widget re-exports this rather than keeping a second copy, because two maps that are
   supposed to agree eventually will not.
   A city absent from here can still be picked by name; it just cannot be resolved to
   from a raw coordinate, which is what nearestServicedCity below needs. */
export const CITY_CENTER_COORDS = {
  "Vijayawada":   "16.5062,80.6480",
  "Visakhapatnam":"17.6868,83.2185",
  "Guntur":       "16.3067,80.4365",
  "Nellore":      "14.4426,79.9865",
  "Kurnool":      "15.8281,78.0373",
  "Rajahmundry":  "17.0005,81.8040",
  "Tirupati":     "13.6288,79.4192",
  "Kakinada":     "16.9891,82.2475",
  "Eluru":        "16.7050,81.0952",
  "Ongole":       "15.5057,80.0499",
  "Hyderabad":    "17.3850,78.4867",
  "Warangal":     "17.9689,79.5941",
  "Nizamabad":    "18.6726,78.0941",
  "Karimnagar":   "18.4386,79.1288",
  "Khammam":      "17.2473,80.1514",
  "Nalgonda":     "17.0575,79.2679",
  "Mahbubnagar":  "16.7448,77.9836",
};

function kmBetween(aLat, aLng, bLat, bLng) {
  const R = 6371, rad = (d) => (d * Math.PI) / 180;
  const dLat = rad(bLat - aLat), dLng = rad(bLng - aLng);
  const x = Math.sin(dLat / 2) ** 2 +
    Math.cos(rad(aLat)) * Math.cos(rad(bLat)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(x));
}

/* The serviced city a point belongs to, decided by distance rather than by whether
   Google happens to print that city's name in the address.
 *
 * resolveServicedCity below can only match a name that appears in the geocode. That
 * works for a suburb inside the city's own postal identity — a Kanuru fix carries
 * "Vijayawada" three results down — and fails completely for a satellite town with an
 * identity of its own: nothing in a Gannavaram geocode says Vijayawada at any level,
 * so a partner there got a blank city field and no explanation.
 *
 * maxKm keeps that honest. Beyond it the nearest city is not a base city, it is just
 * the closest dot on the map, and the caller is better off knowing we do not serve the
 * place than being quietly enrolled somewhere two hours away.
 */
export function nearestServicedCity(lat, lng, maxKm = 60) {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return "";
  let best = "", bestKm = Infinity;
  for (const [city, pair] of Object.entries(CITY_CENTER_COORDS)) {
    const [cLat, cLng] = pair.split(",").map(Number);
    const d = kmBetween(lat, lng, cLat, cLng);
    if (d < bestKm) { bestKm = d; best = city; }
  }
  return bestKm <= maxKm ? best : "";
}

// A city we serve for a name - in English, in another script, or another name for it.
export function findServicedCity(name) {
  return canonicalCity(name);
}

export function resolveServicedCity(addressComponents, formattedAddress = "") {
  const comps = Array.isArray(addressComponents) ? addressComponents : [];

  // 1. By administrative type, narrowest first — the ordinary path.
  for (const type of CITY_COMPONENT_PRIORITY) {
    const c = comps.find((x) => x.types?.includes(type));
    const m = findServicedCity(c?.long_name) || findServicedCity(c?.short_name);
    if (m) return m;
  }

  // 2. Any component at all. Google is not consistent about which level carries the
  //    city for smaller towns, and a component that matches the list is the city
  //    whatever level it arrived on.
  for (const c of comps) {
    const m = findServicedCity(c.long_name) || findServicedCity(c.short_name);
    if (m) return m;
  }

  // 3. The formatted address, narrowest segment first. Covers a place restored from
  //    saved history, which carries the string but not the components.
  for (const seg of String(formattedAddress || "").split(",")) {
    const m = findServicedCity(seg);
    if (m) return m;
  }

  return "";
}

/* The serviced city for a set of coordinates, read across EVERY geocode result.
 *
 * A reverse geocode returns the same point described at a dozen granularities, and only
 * some of them name the city. At a real Kanuru fix, results[0] is the street address —
 * "…Kanuru, Andhra Pradesh 520007" — which does not contain "Vijayawada" at any
 * component level, so reading only the first result could never find the city no matter
 * how carefully it walked the hierarchy. Three results further down, the neighbourhood
 * and postal-code entries both say Vijayawada plainly.
 *
 * So scan them all and take the first serviced match. The results are already in the
 * response; this costs no extra call.
 */
export function resolveServicedCityFromResults(results) {
  for (const r of results || []) {
    const m = resolveServicedCity(r.address_components, r.formatted_address);
    if (m) return m;
  }
  return "";
}

export async function resolveCityFromCoords(lat, lng) {
  if (!window.google?.maps?.Geocoder) return "";
  const geocoder = new window.google.maps.Geocoder();
  const results = await new Promise((resolve) => {
    geocoder.geocode({ location: { lat, lng } }, (res, status) =>
      resolve(status === "OK" && res ? res : [])
    );
  });
  return resolveServicedCityFromResults(results);
}

/* Coordinates for a pickup the customer typed but never picked from the suggestions.
 *
 * Cars are offered by distance from the pickup, so a pickup with no coordinates cannot
 * be matched to anything — the search falls back to comparing city names, which is the
 * behaviour that returned nothing for a Gannavaram pickup. Typing an address is a
 * perfectly ordinary thing to do, so the text is geocoded rather than left unusable.
 *
 * Returns null on any failure; a caller must carry on without coordinates rather than
 * block the booking, exactly as it did before this existed.
 */
export async function geocodeToPoint(text) {
  const q = String(text || "").trim();
  if (!q || !window.google?.maps?.Geocoder) return null;
  try {
    const geocoder = new window.google.maps.Geocoder();
    const results = await new Promise((resolve) => {
      geocoder.geocode({ address: q, componentRestrictions: { country: "IN" } }, (res, status) =>
        resolve(status === "OK" && res ? res : [])
      );
    });
    const loc = results?.[0]?.geometry?.location;
    if (!loc) return null;
    return { lat: loc.lat(), lng: loc.lng() };
  } catch {
    return null;
  }
}

export async function detectCityFromGPS() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      return reject(new Error("Geolocation not supported"));
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        if (!window.google?.maps?.Geocoder) return reject(new Error("Maps not loaded"));
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode(
          { location: { lat: pos.coords.latitude, lng: pos.coords.longitude } },
          (results, status) => {
            if (status !== "OK" || !results?.length) return reject(new Error("Geocode failed"));
            const comp = results[0].address_components || [];
            const address = results[0].formatted_address || "";
            const locality =
              comp.find((c) => c.types.includes("locality"))?.long_name ||
              comp.find((c) => c.types.includes("administrative_area_level_2"))?.long_name ||
              "";
            // The serviced city the GPS fix sits inside, never the suburb it landed on.
            // This used to fall back to the raw locality, which is how "Kanuru" reached
            // the city field and stalled the booking. Read across every result, not just
            // the street address: at a Kanuru fix that first result never names
            // Vijayawada, while the neighbourhood and postal-code results both do.
            // locality is still reported so a caller can say WHERE the customer is when
            // we genuinely do not serve it.
            const city = resolveServicedCityFromResults(results);
            resolve({
              city,
              locality,
              address,
              location: { lat: pos.coords.latitude, lng: pos.coords.longitude },
            });
          }
        );
      },
      (err) => {
        reject(err);
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  });
}

/* Cities added for towns businesses asked for (Oct 2026, mock City_1) - the admin approves
   them with the business, and they join the lists here: the pickers, names typed in any
   script, and the nearest-city lookups. Telugu readers see the Telugu name the admin
   confirmed; other languages the English one until a name is written for them.
   { name, te, lat, lng } each, from GET /api/config/cities (utils/extraCities.js). */
export function addExtraCities(list) {
  let added = 0;
  for (const c of Array.isArray(list) ? list : []) {
    const name = typed(c?.name);
    if (!name || CITY_LIST_AP.includes(name)) continue;
    // Telangana when the nearest listed city is - the pickers group cities by state.
    const near = Number.isFinite(c.lat) && Number.isFinite(c.lng) ? nearestServicedCity(c.lat, c.lng, 400) : "";
    if (near && CITY_LIST_TG.includes(near)) { CITY_LIST_TG.push(name); CITY_LIST_TG.sort(); }
    CITY_LIST_AP.push(name);
    CITY_LIST_AP.sort();
    added++;
    if (Number.isFinite(c.lat) && Number.isFinite(c.lng)) CITY_CENTER_COORDS[name] = `${c.lat},${c.lng}`;
    if (c.te) CITY_NATIVE[name] = [typed(c.te), name, name, name];
    BY_NAME.set(name.toLowerCase(), name);
    if (c.te && !BY_NAME.has(typed(c.te))) BY_NAME.set(typed(c.te), name);
    SOUNDS.push([soundKey(name), name]);
  }
  // Screens that are already open draw their city lists again (useCityList below).
  if (added && typeof window !== "undefined") window.dispatchEvent(new Event(CITIES_EVENT));
}

/* The lists as they are now, added cities included. Read them when drawing - a list
   copied when a module first loads misses every city added after (26 Oct 2026: Ponnuru
   and Mylavaram were added but no picker showed them). */
export const CITIES_EVENT = "sramika:cities";
export const apOnlyCities = () => CITY_LIST_AP.filter((c) => !CITY_LIST_TG.includes(c));
export const allCities = () => [...new Set([...CITY_LIST_AP, ...CITY_LIST_TG])].sort();

// The cities added last time, at once - before any screen draws (utils/extraCities.js
// keeps this copy and fetches the new list).
try {
  if (typeof localStorage !== "undefined") addExtraCities(JSON.parse(localStorage.getItem("sramika_extra_cities") || "[]"));
} catch { /* storage blocked: the fetch adds them */ }
